module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"mobileInterceptor":{"default":"We recommend using a laptop or desktop to use this feature.","broadcast":"We recommend using a non-touchscreen device to enjoy full functionality","campaign":"We recommend using a non-touchscreen device to enjoy full functionality","continueButton":"Got it, let\u0027s go","backButton":"Got it, let\u0027s go back"}}}')
  delete Component.options._Ctor
}
